import { CostCentreServiceBase } from './cost-centre.service.base';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT, HateoasMultipleResponseObject } from '@scisys-uim/uim-common';
import { CostCentre } from 'assets-model';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class CostCentreService extends CostCentreServiceBase {
  constructor(http: HttpClient, @Inject(ENVIRONMENT) environment: any) {
    super(http, environment);
  }

  public findAllByBusinessUnit(buId: string, reduced: boolean = true): Observable<HateoasMultipleResponseObject<CostCentre>> {
    return this.deserialiseMultipleResponse(this.http.get<HateoasMultipleResponseObject<CostCentre>>(this.serviceBaseUrl + '/findAllByBusinessUnit/' + buId));
  }

  public findByBusinessUnitForType(buId: string, type: string, reduced: boolean = true): Observable<HateoasMultipleResponseObject<CostCentre>> {
    return this.deserialiseMultipleResponse(this.http.get<HateoasMultipleResponseObject<CostCentre>>(this.serviceBaseUrl + '/findByBusinessUnitForType/' + buId + "/" + type));
  }
}



